var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconResultsPref(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_286_3438)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1624 3.5293H7.25184V5.95518L-0.0183105 5.95518V17.334C-0.0183105 21.7317 4.88948 25.3505 9.70595 25.7269C11.2871 27.4211 14.0683 28.6516 16.5436 29.1764V32.1505C14.1765 32.8775 9.94831 34.5857 9.70595 36.4469H25.9508C25.7061 34.5857 21.0471 32.8752 18.6754 32.1505V29.1764C21.1601 28.6516 24.066 27.4211 25.6495 25.7269C30.4636 25.3505 35.1554 21.7317 35.1554 17.334V5.95518H28.1624V3.5293ZM2.21419 8.11139H7.08242V17.9128C7.08242 19.8469 7.58125 21.6869 8.45889 23.3434C4.81654 22.1834 2.21419 19.1952 2.21419 15.6987V8.11139ZM21.2829 20.0658L17.6491 18.0634L14.0114 20.0658L14.706 15.8305L11.7648 12.8328L15.8283 12.214L17.6491 8.36459L19.466 12.214L23.5295 12.8328L20.5903 15.8305L21.2829 20.0658ZM26.6824 23.6564C27.5648 21.9246 28.0707 20.0093 28.0707 17.9834V8.17458H32.9507V15.6705C32.9507 19.3246 30.3365 22.4446 26.6824 23.6564Z",
    fill: "#005B38"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_286_3438"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconResultsPref);
export default __webpack_public_path__ + "static/media/icon-results-pref.c0e907f06af023e13e885fb486251867.svg";
export { ForwardRef as ReactComponent };